
jQuery(($) => {
  let $wrapper = $('.intermediate-wrapper');
  let $list = $wrapper.find('.card-list');

  let $clonedList = $list.clone().addClass('cloned').appendTo($wrapper);

  // height of one card (all same height)
  let cardHeight = $('.scroll-card').outerHeight(true); 
  let cardLength = $list.find('.scroll-card').length;
  let listHeight = cardHeight * cardLength;

  // Set heights
  $list.add($clonedList).css({ height: listHeight + 'px' });

  // GSAP infinite scroll
  let infinite = gsap.timeline({ repeat: -1, paused: false });
  let time = cardLength * 3; // 3s per card

  infinite
    .fromTo(
      $list,
      { y: 0 },
      { y: -listHeight, duration: time, ease: "linear" },
      0
    )
    .fromTo(
      $clonedList,
      { y: listHeight },
      { y: 0, duration: time, ease: "linear" },
      0
    );

  // Pause on hover
  $wrapper.on('mouseenter', () => infinite.pause());
  $wrapper.on('mouseleave', () => infinite.play());
});

